import { IApiResponse } from 'utils/models';

export type TabsType = 0 | 1 | 2 | 3 | false;

export interface IFormValues {
  sourceAccount: string;
  amount: string;
  destinationAccountNo: string;
  narration: string;
  frequency: string;
  startDate?: string
  transferType?: string;
}

export interface IScheduleTransfer {
  transactionId: string;
  scheduleId: string;
  sourceAccount: number;
  // SourceAccountType: string;
  destinationAccountName: string;
  destinationAccountNo: string;
  transactionAmount: number;
  transactionNarration: string;
  // transactionCharge: string;
  // createdby: string;
  createDate: string;
  transactionType: string;
  frequency: string;
}

export interface IApiScheduleTransfer extends IApiResponse {
  transactions: IScheduleTransfer[];
  size: number;
}

export interface IBank {
  code: string;
  name: string;
}

export const types = [
  { name: 'INSTANT TRANSFER', key: 'INSTANT' },
  { name: 'NON-INSTANT TRANSFER', key: 'NON_INSTANT' },
];

export interface ITransfersState {
  banks: IBank[];
  types: typeof types;
}

export enum TransferType {
  OWN_TRANSFER ='OWN-TRANSFER',
  LOCAL_TRANSFER = 'LOCAL-TRANSFER',
  OTHERBANK_TRANSFER = 'OTHERBANK-TRANSFER',
  BULK_TRANSFER = 'BULK-TRANSFER'
}
